export const useLogout = ({ isMobile }: { isMobile: boolean }) => {
  const { fetchLogout } = useFetchLogout()
  const { fetch: fetchQueryInitInfo } = useQueryInitInfo({ isMobile })

  const logout = async () => {
    await fetchLogout()
    await fetchQueryInitInfo()
  }

  return {
    logout
  }
}
export default useLogout
